import React from "react";
import useTournamentStream from "../hooks/useTournamentStream";
import Div from "../lib/Div";
import {colors} from "../assets/styles/colors";
import {ImageBackground, StyleSheet, ScrollView, Image, Platform} from "react-native";
import plusIcon from "../assets/img/Group 48096341.svg";
import MainStyle from "../../MainStyle";
import {LinearGradient} from 'expo-linear-gradient';
import P from "../lib/P";
import moment from "moment";
import {QRCodeCanvas} from 'qrcode.react';
import {formatCurrency} from "../utils";
import AddNewPromoCode from "./User/promos/components/AddNewPromoCode";
import {useNavigation, useRoute} from "@react-navigation/native";

const TV = () => {
  const route = useRoute();
  const params: any = route?.params;
  const tournamentId = params?.tournament_id;
  const {tournament} = useTournamentStream(tournamentId);
  const url = Platform.OS === 'web' ? location.origin : '';
  const navigation: any = useNavigation();

  return (
    <Div style={[MainStyle.bc_green, MainStyle.flex1]}>
      <ImageBackground source={plusIcon as any} style={MainStyle.flex1} resizeMode="repeat">
        <ScrollView contentContainerStyle={[MainStyle.flex1, MainStyle.row, MainStyle.j_c_s_between]}>
          {tournamentId === undefined ? (
            <></>
          ) : (
            <>
              <Div w={370}>
                <Div h={506} roundedRight={28} borderColor={colors.filter_modal_bg} borderWidth={1} mt={52}
                     style={MainStyle.gradientShadow} bg={colors.newGreenText} overflow="hidden" pt={3} mb={32}>
                  <Div bg={colors.purple} roundedTopRight={28} flex={1} overflow="hidden">
                    <LinearGradient colors={['rgba(0,0,0,0.25)', 'rgba(0,0,0,0)']} start={{x: 0.5, y: 0}}
                                    end={{x: 0.5, y: 1}} style={[StyleSheet.absoluteFill, MainStyle.j_c_c]}>
                      {tournament?.sponsorLogo && (
                        <Div h={290} w={290} bg="white" rounded={10} mx="auto" overflow="hidden" justifyContent="center"
                             alignItems="center">
                          <Image
                            source={{uri: tournament.sponsorLogo}} resizeMode="contain"
                            style={[{width: 370, height: 370}]}
                          />
                        </Div>
                      )}
                    </LinearGradient>
                  </Div>
                </Div>

                <Div h={325} roundedRight={28} borderColor={colors.filter_modal_bg} borderWidth={1} overflow="hidden"
                     style={MainStyle.gradientShadow} bg={colors.newGreenText} pt={3}>
                  <Div bg={colors.purple} roundedTopRight={28} flex={1} overflow="hidden">
                    <LinearGradient colors={['rgba(0,0,0,0.25)', 'rgba(0,0,0,0)']} start={{x: 0.5, y: 0}}
                                    end={{x: 0.5, y: 1}} style={[StyleSheet.absoluteFill, MainStyle.j_c_c]}>
                      <P color={colors.rankColor} style={MainStyle.textShadow3} fs={40} fw="700" tt="uppercase" lh={72}
                         ta="center">
                        Prizes*
                      </P>
                      {tournament?.prizePool.slice(0, 3).map((prize, i) => (
                        <P key={i} style={MainStyle.textShadow3} fs={48} fw="700" ta="center">
                          {i === 0 ? '1st:' : i === 2 ? '2nd:' : '3rd:'} {formatCurrency(prize / 100)}
                        </P>
                      ))}
                    </LinearGradient>
                  </Div>
                </Div>
              </Div>

              <Div flex={1} maxW={1100} mx={40}>
                <Div rounded={28} borderColor={colors.filter_modal_bg} borderWidth={1} mt={32}
                     style={MainStyle.gradientShadow} bg={colors.newGreenText} overflow="hidden" pt={6}>
                  <Div bg={colors.purple} roundedTop={28} flex={1} overflow="hidden">
                    <LinearGradient colors={['rgba(0,0,0,0.25)', 'rgba(0,0,0,0)']} start={{x: 0.5, y: 0}}
                                    end={{x: 0.5, y: 1}}
                                    style={MainStyle.p_t_28}>
                      <P ta="center" fs={80} fw="700" style={MainStyle.textShadow10} color={colors.yellowText}>
                        {tournament?.name}
                      </P>

                      <P ta="center" fs={80} fw="700" style={MainStyle.textShadow10} color={colors.yellowText} mb={30}>
                        LEADERBOARD
                      </P>

                      <Div row justifyContent="space-around">
                        <Div alignItems="center">
                          <P color={colors.rankColor} style={MainStyle.textShadow3} fs={32} fw="700" tt="uppercase"
                             mb={20}>
                            Rank
                          </P>
                          {tournament?.leaderboardEntries.map((el, i) => (
                            <P key={i} style={MainStyle.textShadow3} fs={48} fw="700" mb={12}>{el.rank}</P>
                          ))}
                        </Div>

                        <Div alignItems="center" flexShrink={1}>
                          <P color={colors.rankColor} style={MainStyle.textShadow3} fs={32} fw="700" tt="uppercase"
                             mb={20}>
                            Name
                          </P>
                          {tournament?.leaderboardEntries.map((el, i) => (
                            <P key={i} style={MainStyle.textShadow3} fs={48} fw="700" numberOfLines={1} mb={12}>
                              {el.playerUsername}
                            </P>
                          ))}
                        </Div>

                        <Div alignItems="center">
                          <P color={colors.rankColor} style={MainStyle.textShadow3} fs={32} fw="700" tt="uppercase"
                             mb={20}>
                            SCORE
                          </P>
                          {tournament?.leaderboardEntries.map((el, i) => (
                            <P key={i} style={MainStyle.textShadow3} fs={48} fw="700" mb={12}>{el.score}</P>
                          ))}
                        </Div>

                        <Div alignItems="center">
                          <P color={colors.rankColor} style={MainStyle.textShadow3} fs={32} fw="700" tt="uppercase"
                             mb={20}>
                            Shots
                          </P>
                          {tournament?.leaderboardEntries.map((el, i) => (
                            <P key={i} style={MainStyle.textShadow3} fs={48} fw="700" mb={12}>{el.shotsCompleted}</P>
                          ))}
                        </Div>
                      </Div>
                    </LinearGradient>
                  </Div>
                </Div>

                <P fs={24} fw="700" lh={40} ta="center">
                  * See T&C and details at <P fs={24} fw="700" textDecorationLine="underline">Evenplay.com/Promos</P>
                </P>
              </Div>

              <Div w={370}>
                <Div h={220} roundedLeft={28} borderColor={colors.filter_modal_bg} borderWidth={1} mt={52}
                     style={MainStyle.gradientShadow} bg={colors.newGreenText} overflow="hidden" pt={3} mb={32}>
                  <Div bg={colors.purple} roundedTopLeft={28} flex={1} overflow="hidden">
                    <LinearGradient colors={['rgba(0,0,0,0.25)', 'rgba(0,0,0,0)']} start={{x: 0.5, y: 0}}
                                    end={{x: 0.5, y: 1}} style={[StyleSheet.absoluteFill, MainStyle.j_c_c]}>
                      {!!tournament?.expirationDate && (
                        <>
                          <P style={MainStyle.textShadow3} fs={48} fw="700" lh={72} ta="center">
                            {moment.unix(Number(tournament.expirationDate)).format('ll')}
                          </P>

                          <P color={colors.rankColor} style={MainStyle.textShadow3} fs={32} fw="700" ta="center"
                             tt="uppercase" lh={40}>
                            Ends At:
                          </P>

                          <P style={MainStyle.textShadow3} fs={48} fw="700" lh={72} ta="center">
                            {moment.unix(Number(tournament.expirationDate)).format('LT')}
                          </P>
                        </>
                      )}
                    </LinearGradient>
                  </Div>
                </Div>

                <Div h={254} roundedLeft={28} borderColor={colors.filter_modal_bg} borderWidth={1} overflow="hidden"
                     style={MainStyle.gradientShadow} bg={colors.newGreenText} pt={3} mb={32}>
                  <Div bg={colors.purple} roundedTopLeft={28} flex={1} overflow="hidden">
                    <LinearGradient colors={['rgba(0,0,0,0.25)', 'rgba(0,0,0,0)']} start={{x: 0.5, y: 0}}
                                    style={[StyleSheet.absoluteFill, MainStyle.p_x_20, MainStyle.j_c_c]}
                                    end={{x: 0.5, y: 1}}>
                      <P color={colors.rankColor} style={MainStyle.textShadow3} fs={40} fw="700" lh={72} ta="center">
                        NEXT UP:
                      </P>

                      {tournament?.players.slice(0, 2).map((el, i) => (
                        <P key={i} style={MainStyle.textShadow3} fs={48} fw="700" lh={72} ta="center" numberOfLines={1}>
                          {el.playerUsername}
                        </P>
                      ))}
                    </LinearGradient>
                  </Div>
                </Div>

                <Div h={325} roundedLeft={28} borderColor={colors.filter_modal_bg} borderWidth={1} overflow="hidden"
                     style={MainStyle.gradientShadow} bg={colors.newGreenText} pt={3}>
                  <Div bg={colors.purple} roundedTopLeft={28} flex={1} overflow="hidden">
                    <LinearGradient colors={['rgba(0,0,0,0.25)', 'rgba(0,0,0,0)']} start={{x: 0.5, y: 0}}
                                    end={{x: 0.5, y: 1}} style={StyleSheet.absoluteFill}>
                      <P color={colors.rankColor} style={MainStyle.textShadow3} fs={40} fw="700" lh={72} ta="center"
                         mt={18} tt="uppercase" mb={10}>
                        Join Now
                      </P>

                      {(tournament?.id && url) && (
                        <Div w={180} h={180} justifyContent="center" alignItems="center" bg="white" rounded={10}
                             mx="auto">
                          <QRCodeCanvas value={`${url}/tournament?id=${tournament.id}`} size={150}/>
                        </Div>
                      )}
                    </LinearGradient>
                  </Div>
                </Div>
              </Div>
            </>
          )}
        </ScrollView>
      </ImageBackground>

      <AddNewPromoCode
        isOpen={tournamentId === undefined} inputType="numeric"
        title="Add Tournament ID" inputPlaceholder="Tournament ID"
        onSubmit={val => navigation.navigate('TV', {tournament_id: val})}
      />
    </Div>
  );
};

export default TV;
